import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentCode16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDocumentCode16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 14a1 1 0 0 0 1-1V7H8V2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1zM9 6h3.98a1 1 0 0 0-.312-.544l-3.566-3.2.668-.744 3.566 3.2A2 2 0 0 1 14 6.2V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.434a2 2 0 0 1 1.336.512l-.668.744A1 1 0 0 0 9 2.176zm-4.354.646a.5.5 0 0 1 .708 0L7.597 8.89l.354.354-.354.353-2.243 2.244a.5.5 0 0 1-.708-.707l1.89-1.89-1.89-1.89a.5.5 0 0 1 0-.708M7.5 11.5A.5.5 0 0 1 8 11h3a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentCode16);
